import { Route } from '@angular/router';
import { ContentPageComponent, ContentPageRouteComponent } from '@libs/features/cep';
import { AgentGuardService, AuthGuardService, LoginRedirectGuardService } from '@libs/shared/auth';
import { AGENT_LOGIN_ROUTE_PATH, AGENT_PAGE_ROUTE_PATH } from '@libs/shared/models';
import { AgentComponent, AgentLoginComponent } from '@libs/templates/cep';

// istanbul ignore file
export const cepBaseRoutes: Route[] = [
  {
    path: '',
    component: ContentPageComponent,
    children: [
      {
        path: '',
        loadChildren: () => import('./cep-authenticated.module').then(m => m.CepAuthenticatedModule),
        canActivate: [AuthGuardService],
      },
      {
        path: 'auth',
        component: ContentPageRouteComponent,
        canActivate: [LoginRedirectGuardService],
      },
      {
        path: AGENT_LOGIN_ROUTE_PATH,
        component: AgentLoginComponent,
        canActivate: [LoginRedirectGuardService],
      },
      {
        path: AGENT_PAGE_ROUTE_PATH,
        component: AgentComponent,
        canActivate: [AgentGuardService],
      },
    ],
  },
  {
    path: '**',
    redirectTo: 'auth',
  },
];
